import {SeuilEgalimDto} from "./seuil-egalim-dto";

export class StatistiqueEgalimConformite {
  annee: number;
  pointTeledeclarationLibelle: string;
  pourcentageDurable: number;
  pourcentageBio: number;
  pourcentageMontantProduitsPoissonViande: number;
  seuils: SeuilEgalimDto[];
  isConforme: boolean;
}
